<template>
  <div class="major">
    <div class="box">
      <h1 align="center">专业信息</h1>
      <el-divider></el-divider>
    </div>

    <el-row>
      <el-button type="primary" class="dalfbut" id="pb"
        >本科(普通教育)</el-button
      >
      <el-button type="primary" class="dalfbut" id="zb"
        >本科(职业教育)</el-button
      >
      <el-button type="primary" class="dalfbut" id="zk">职高(专科)</el-button>
    </el-row>

    <el-divider></el-divider>
    <div class="box2">
      <el-row class="tac">
        <el-col :span="4">
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            background-color="#ffffff"
            text-color="#000"
            active-text-color="#70cba9"
          >
            <el-menu-item index="0">
              <h4>门类</h4>
            </el-menu-item>
            <el-menu-item
              v-for="list in cateList"
              :key="list.id"
              :index="list.categoryCode"
              @click="sendCode"
            >
              <span slot="title">{{ list.categoryName }}</span>
            </el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="4">
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            background-color="#ffffff"
            text-color="#000"
            active-text-color="#70cba9"
          >
            <el-menu-item index="0">
              <h4>专业类</h4>
            </el-menu-item>
            <el-menu-item
              v-for="list in proClassList"
              :key="list.professionClassCode"
              :index="list.professionClassCode"
              @click="sendProClassCode"
            >
              <span slot="title">{{ list.professionClassName }}</span>
            </el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="16">
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            background-color="#ffffff"
            text-color="#000"
            active-text-color="#70cba9"
          >
            <el-menu-item index="0" class="proInfo">
              <ul>
                <li>
                  <h4>专业名称</h4>
                </li>
                <li>
                  <h4>专业代码</h4>
                </li>
                <li>
                  <h4>满意度</h4>
                </li>
              </ul>
            </el-menu-item>
            <el-menu-item
              class="proInfo"
              v-for="list in proInfoList"
              :key="list.code"
              :index="list.code"
            >
              <ul>
                <li>
                  <template>
                    <router-link
                      :to="{
                        path: '/configuration/professionInfo?',
                        query: { code: list.code },
                      }"
                      target="_blank"
                      >{{ list.name }}</router-link
                    >
                  </template>
                </li>
                <li>{{ list.code }}</li>
                <li v-if="list.score != 0">{{ list.score }}</li>
                <li v-else>{{ list.score }}</li>
              </ul>
            </el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import category from "../../api/configuration";
export default {
  data() {
    return {
      cateList: [],
      proClassList: [],
      proInfoList: [],
      code: "105001",
      proClassCode: "10500101",
      type: "pb",
    };
  },
  methods: {
    getCategory() {
      category.getCategory().then((res) => {
        this.cateList = res.list;
      });
    },
    getProfessionClassByCode(code) {
      category.getProfessionClassByCode(code).then((res) => {
        this.proClassList = res.list;
      });
    },
    getProfessionInfo(code) {
      category.getProfessionInfoByCode(code).then((res) => {
        this.proInfoList = res.list;
      });
    },
    sendCode(e) {
      this.code = e.index;
      this.proClassCode = this.code + "01";
      this.getProfessionClassByCode(this.code);
      this.getProfessionInfo(this.proClassCode);
    },
    sendProClassCode(e) {
      this.proClassCode = e.index;
      this.getProfessionInfo(this.proClassCode);
    },
  },
  created() {
    this.getCategory();
    this.getProfessionClassByCode(this.code);
    this.getProfessionInfo(this.proClassCode);
  },
  mounted() {
    var type = this.type;
    document.getElementById(type).style.backgroundColor = "#1db278";
    document.getElementById(type).style.color = "#fff";
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.box2 {
  background-color: #fff;
}
.box h1 {
  font-weight: 300;
  margin-bottom: 10px;
  margin-bottom: 10px;
  background-color: #f0f0f0;
}

.box i {
  font-style: normal;
  font-size: 14px;
  color: #ccc;
}

.dalfbut {
  width: 200px;
  height: 40px;
  border-radius: 4px;
  background-color: #66b1ff;
  color: #fff;
  margin: 20px 0;
  margin-right: 20px;
  background-color: #fff;
  color: #000;
  border: 1px solid #1db278;
}
.dalfbut:hover {
  color: #fff;
  background-color: #1db278;
}

a {
  color: #606266;
}

a:hover {
  color: #1cb278;
  text-decoration: underline;
}

.proInfo ul {
  display: flex;
  list-style: none;
}
.proInfo ul li {
  float: left;
  flex: 1;
  text-align: center;
}
</style>

